import { GraphQlClient } from '@intelipost-js/secure-providers';

export default {
  getMacroStates({ commit }) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
      query {
        getMacroStates {
          description,
          id,
        }
      }`)
      .then((res) => {
        const {
          data = {},
        } = res || {};
        const {
          getMacroStates = [],
        } = data || {};

        commit('toggleLoading', false);
        commit('setShipperMacroStates', getMacroStates);
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },

  getMicroStateByMacroId({ commit }, params) {
    const {
      macro_id,
      source_id,
    } = params;
    const id = !macro_id ? 0 : macro_id;

    return GraphQlClient.query(`
      query(
        $id: Int!,
        $source_id: Int!,
        ) {
        getMicroStateByMacroId(
          id: $id,
          source_id: $source_id,
        ) {
          id,
          code,
          description,
        }
      }`, {
        id,
        source_id,
      })
      .then((res) => {
        const {
          data = {},
        } = res || {};
        const {
          getMicroStateByMacroId = [],
        } = data || {};
        commit('toggleLoading', false);
        commit('setShipperMicroStates', getMicroStateByMacroId);
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
};



// WEBPACK FOOTER //
// ./src/stores/order-status/actions.js